import setAsyncSendState from './setAsyncSendState';
import { ComposeViewState, ComposeOperation, AsyncSendState } from 'owa-mail-compose-store';
import { lazyLoadDraftToCompose } from 'owa-mail-compose-actions';
import moveComposeToTab from 'owa-mail-compose-actions/lib/actions/moveComposeToTab';
import { action } from 'satcheljs/lib/legacy';

export default action('cancelSend')(function cancelSend(viewState: ComposeViewState) {
    // Reopen the compose editor
    // 1. In the drafts folder, load the draft to compose (VSO 36275)
    // 2. In tabview full compose, open the full compose form in a new tab (VSO 34954)
    // 3. In tabview inline compose, handling is done in updateSecondaryReadingPaneTabOrchestrator
    setAsyncSendState(viewState, AsyncSendState.None);
    if (viewState.operation === ComposeOperation.EditDraft) {
        lazyLoadDraftToCompose.importAndExecute(viewState.itemId.Id);
    } else if (!viewState.isInlineCompose) {
        moveComposeToTab(viewState, true /* isShown */, true /* makeActive */);
    }
});
